export default {
    steps: {
        entries: {
            title: 'Pierwsze wpisy',
            action: 'Powiedz, co dodać',
            what: 'Powiedz albo wpisz, co masz dziś w planach — asystent ułoży to w planerze.',
            why: 'Planer pokazuje cały dzień na jednej osi: spotkania, zadania, posiłki, sen i treningi.',
        },
        calendar: {
            title: 'Kalendarz Google',
            action: 'Połącz',
            what: 'Połącz swój Google Calendar.',
            why: 'Spotkania z kalendarza staną w planerze obok reszty dnia — bez przepisywania.',
        },
        profile: {
            title: 'Profil',
            action: 'Uzupełnij',
            what: 'Płeć, waga i wzrost — wszystko opcjonalne.',
            why: 'Płeć pozwala zwracać się do Ciebie właściwą formą, a waga i wzrost przydają się przy posiłkach i formie.',
        },
        phone: {
            title: 'Rountine na telefonie',
            action: 'Jak to zrobić',
            what: 'Dodaj Rountine do ekranu telefonu — otwiera się jak aplikacja.',
            why: 'Planer masz pod ręką w ciągu dnia: odhaczysz zadanie i podyktujesz wpis w biegu.',
        },
    },
    tiles: {
        assistant: { label: 'Asystent', hint: 'Rozmowa' },
        planner: { label: 'Planer', hint: 'Dzień' },
        planer2Tasks: { label: 'Zadania', hint: 'Planer' },
        basket: { label: 'Koszyk', hint: 'Do kupienia' },
        shopping: { label: 'Lista zakupowa', hint: 'Stare zakupy' },
        notes: { label: 'Notatnik', hint: 'Notatki' },
        places: { label: 'Miejsca', hint: 'Mapa' },
        wallet: { label: 'Portfel', hint: 'Do wydania' },
        walletPlans: { label: 'Płatności', hint: 'Portfel' },
        walletTransactions: { label: 'Transakcje', hint: 'Portfel' },
        meals: { label: 'Posiłki', hint: 'Stare Jedzenie' },
        mealPlan: { label: 'Plan posiłków', hint: 'Stare Jedzenie' },
        foodToday: { label: 'Jedzenie', hint: 'Dziś' },
        forma: { label: 'Forma', hint: 'Teraz' },
        sleep: { label: 'Sen', hint: 'Forma' },
        weight: { label: 'Waga', hint: 'Forma' },
        projects: { label: 'Projekty', hint: 'Zadania' },
        people: { label: 'Ludzie', hint: 'Urodziny i prezenty' },
        pets: { label: 'Zwierzęta', hint: 'Szczepienia i waga' },
        devices: { label: 'Sprzęty', hint: 'Serwisy i gwarancje' },
        habits: { label: 'Nawyki', hint: 'Odhacz dzisiejsze' },
        medications: { label: 'Leki', hint: 'Dawki na dziś' },
        expenses: { label: 'Wydatki', hint: 'Finanse' },
    },
    screen: {
        close: 'Zamknij',
        greeting: {
            night: 'Dobranoc',
            morning: 'Dzień dobry',
            afternoon: 'Cześć',
            evening: 'Dobry wieczór',
        },
        // z imieniem użytkownika: „Dzień dobry, Paweł”
        greetingNamed: '{greeting}, {name}',
        question: 'Co chcesz otworzyć?',
        record: 'Powiedz asystentowi',
        recordHint: 'Co robisz, jesz, wydajesz albo planujesz — zapisze resztę.',
        quickHeading: 'SZYBKI WYBÓR',
        quick: 'Szybki wybór',
        customise: 'Dostosuj',
        allModules: 'WSZYSTKIE MODUŁY',
        showOnOpen: 'Pokazuj po otwarciu aplikacji',
    },
};
